import { INC, DEC, badgeDec, badgeInc } from "./../action/badge_adction";

const initialState = {
  counter: 0,
};

const BadgeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INC":
      console.log("inc reduc");
      return {
        ...state,
        counter: action.preloader,
      };
    case "DEC":
      console.log("dec reduc");
      return {
        ...state,
        counter: action.preloader,
      };

    default:
      return state;
  }
};
export default BadgeReducer;
